<template>
  <div>
    <!-- Upload Area -->
    <div
      class="flex flex-col justify-center items-center bg-[#F8F8F8] border-2 border-[#E2E2E2] border-dashed p-[5rem] rounded-lg mb-[1rem] cursor-pointer"
      @click="openFilePicker"
      @dragover.prevent
      @drop.prevent="handleDrop"
    >
      <span class="k-document-upload !text-[40px]" />

      <p class="mt-[2rem] mb-[.5rem] text-[20px] font-medium">
        Klik atau drag file ke area ini untuk unggah
      </p>

      <p class="text-[#626262]">
        Mendukung untuk unggahan tunggal atau masal
      </p>

      <input
        ref="fileInput"
        type="file"
        accept="image/*"
        class="hidden"
        multiple
        @change="handleFileChange"
      >
    </div>

    <!-- File List -->
    <ul
      v-if="files.length"
      class="mb-[1rem]"
    >
      <li
        v-for="(file, index) in files"
        :key="index"
        class="flex items-center gap-[.5rem] hover:bg-[#F8F8F8] rounded-md ps-[.5rem]"
      >
        <span class="k-paperclip-2 !text-[16px]" />

        <span class="!text-[14px] !text-[#08A0F7]">
          {{ file.name }}
        </span>

        <BButton
          variant="link"
          class="!ms-auto !p-[.5rem]"
          @click="removeFile(index)"
        >
          <span class="k-trash !text-[16px]" />
        </BButton>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'UploadArea',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    files() {
      return this.value
    },
  },

  methods: {
    openFilePicker() {
      this.$refs.fileInput.click()
    },

    handleFileChange(event) {
      const input = event.target
      const newFiles = Array.from(input.files)
      const updated = [...this.files, ...newFiles]
      this.$emit('input', updated)
      input.value = ''
    },

    handleDrop(event) {
      const droppedFiles = Array.from(event.dataTransfer.files)
      const updated = [...this.files, ...droppedFiles]
      this.$emit('input', updated)
    },

    removeFile(index) {
      const updated = [...this.files]
      updated.splice(index, 1)
      this.$emit('input', updated)
    },
  },
}
</script>
